import React from "react";
import { LandingLayout } from "../index";
import { Box, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import EstimateBenefitsForm from "./EstimateBenefitsForm";
import PremiumCardWrap from "./PremiumCard/PremiumCardWrap";
import PolicyMainCard from "./TotalPaid/PolicyMainCard";
import PotentialCardWrap from "./PotentialCashValueCard";
import headerImage from "../Assets/headerImage.png";
import Button from "@material-ui/core/Button";
import TrustStructure from "../Assets/TrustStructure.png";
import { useHistory } from "react-router-dom";
import { getQueryStringValue } from "../../../utils/queryString";

const useDashboardStyles = makeStyles((theme) => ({
    root: {
        background: "#02182b",
        padding: 15,
        borderRadius: 15,
    },
    middleColumn: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
}));

const EstimateBenefitsStart = () => {
    const classes = useDashboardStyles();
    const [estimationResponse, setEstimationResponse] = React.useState<any>(null);
    const inviteToken = getQueryStringValue("token");
    const [token, setToken] = React.useState<any>(inviteToken);
    const history = useHistory();

    const PCClick = () => {
        window.scrollTo(0, 0);
        history.push(`/accept/invitation/${token}`);
    };


    return (
            <LandingLayout>
                <Container maxWidth="lg">
                    <Box py={8}>
                        <Grid container spacing={2} justify="center" alignItems="center">
                            <Grid item xs={12} style={{ textAlign: "center" }}>
                                <Typography component="span">
                                    <img src={headerImage} alt="headerImage" />
                                </Typography>
                                <Typography variant="h1">Your <span style={{ color: "rgb(7, 184, 248)" }}> estimated benefits </span> dashboard</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <div className={classes.root}>
                        <Grid container spacing={4} justify="center">
                            <Grid item xs={12} lg={6}>
                                <EstimateBenefitsForm setEstimationResponse={setEstimationResponse}
                                                      estimationResponse={estimationResponse} />
                            </Grid>

                            <Grid item xs={12} lg={6}>
                                <PolicyMainCard estimationResponse={estimationResponse} />

                                <PremiumCardWrap estimationResponse={estimationResponse} />
                            </Grid>
                            <Grid item xs={12} lg={12}>
                                <PotentialCardWrap estimationResponse={estimationResponse} />
                            </Grid>

                        </Grid>
                    </div>
                    <Grid container spacing={4} justify="center">
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Button variant="contained" color="primary" onClick={PCClick} className="mt25">Start Enrollment</Button>
                        </Grid>
                    </Grid>
                    <Box py={8}>
                        <Grid container spacing={2} justify="center" alignItems="center">
                            <Grid item xs={12} style={{ textAlign: "center" }}>
                                <Typography component="span" align="center">
                                    <img src={headerImage} alt="headerImage" />
                                </Typography>
                                <Typography variant="h1" align="center">Your Take a peek <span
                                        style={{ color: "rgb(7, 184, 248)" }}>under the hood</span> of
                                    your policy</Typography>
                                <Typography variant="subtitle1" className="mb20" align="center">Underneath the sleek
                                    exterior of the
                                    Kai-Zen strategy lies a
                                    sophisticated trust structure that helps limit your financial exposure and secure
                                    more
                                    favorable loan terms. </Typography>
                                <img src={TrustStructure} alt="TrustStructure" />
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: "center" }}>
                                <Button variant="contained" color="primary">Next</Button>
                            </Grid>
                        </Grid>

                    </Box>

                </Container>
            </LandingLayout>
    );
};

export default EstimateBenefitsStart;